import { PageFiltersElement } from '../../../../components/PageFilters/types';
import { auditTrailComponentFilterKey, ComponentFilter } from './ComponentFilter';
import { auditTrailDateTimeFilterKey, DateTimeStartEndFilter } from './DateTimeStartEndFilter';
import { MetadataFilter } from './MetadataFilter';
import { StringFilter } from './StringFilter';
import { StringRegExFilter } from './StringRegExFilter';
import {
  AuditTrailFilterComponent,
  AuditTrailFilterDateTimeValue,
  AuditTrailFilterMetadata,
  AuditTrailFiltersConfig,
  AuditTrailFilterString,
  AuditTrailFilterStringRegEx,
  AuditTrailFilterUser,
} from './types';
import { auditTrailUserFilterKey, UserFilter } from './UserFilter';

const auditTrailDateTimeFilter: PageFiltersElement<AuditTrailFilterDateTimeValue> = {
  key: auditTrailDateTimeFilterKey,
  filterName: 'Date and Time',
  render: (value, onChange, label, key, disabled) => (
    <DateTimeStartEndFilter value={value} onChange={onChange} disabled={disabled} inputLabel={label} key={key} />
  ),
};

const auditTrailUserFilter: PageFiltersElement<AuditTrailFilterUser> = {
  key: auditTrailUserFilterKey,
  filterName: 'User',
  render: (value, onChange, label, key, disabled) => (
    <UserFilter value={value} onChange={onChange} disabled={disabled} inputLabel={label} key={key} />
  ),
};

const auditTrailComponentFilter: PageFiltersElement<AuditTrailFilterComponent> = {
  key: auditTrailComponentFilterKey,
  filterName: 'Component',
  render: (value, onChange, label, key, disabled) => (
    <ComponentFilter value={value} onChange={onChange} disabled={disabled} inputLabel={label} key={key} />
  ),
};

export const auditTrailEventSourceFilterKey = 'audit-trail-event-source-filter';
const auditTrailEventSourceFilter: PageFiltersElement<AuditTrailFilterStringRegEx> = {
  key: auditTrailEventSourceFilterKey,
  filterName: 'Event Source',
  inputLabel: 'Event Source',
  render: (value, onChange, label, key, disabled) => (
    <StringRegExFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailWorkspaceFilterKey = 'audit-trail-workspace-filter';
const auditTrailWorkspaceFilter: PageFiltersElement<AuditTrailFilterStringRegEx> = {
  key: auditTrailWorkspaceFilterKey,
  filterName: 'Workspace',
  inputLabel: 'Workspace',
  render: (value, onChange, label, key, disabled) => (
    <StringRegExFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailResourceFilterKey = 'audit-trail-resource-filter';
const auditTrailResourceFilter: PageFiltersElement<AuditTrailFilterStringRegEx> = {
  key: auditTrailResourceFilterKey,
  filterName: 'Resource',
  inputLabel: 'Resource',
  render: (value, onChange, label, key, disabled) => (
    <StringRegExFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailStatusFilterKey = 'audit-trail-status-filter';
const auditTrailStatusFilter: PageFiltersElement<AuditTrailFilterString> = {
  key: auditTrailStatusFilterKey,
  filterName: 'Status',
  inputLabel: 'Status Code',
  render: (value, onChange, label, key, disabled) => (
    <StringFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailPrincipalFilterKey = 'audit-trail-principal-filter';
const auditTrailPrincipalFilter: PageFiltersElement<AuditTrailFilterStringRegEx> = {
  key: auditTrailPrincipalFilterKey,
  filterName: 'Principal',
  inputLabel: 'Principal',
  render: (value, onChange, label, key, disabled) => (
    <StringRegExFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailIPAddressFilterKey = 'audit-trail-ip-address-filter';
const auditTrailIPAddressFilter: PageFiltersElement<AuditTrailFilterStringRegEx> = {
  key: auditTrailIPAddressFilterKey,
  filterName: 'IP Address',
  inputLabel: 'IP Address',
  render: (value, onChange, label, key, disabled) => (
    <StringRegExFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailActionFilterKey = 'audit-trail-action-filter';
const auditTrailActionFilter: PageFiltersElement<AuditTrailFilterStringRegEx> = {
  key: auditTrailActionFilterKey,
  filterName: 'Action',
  inputLabel: 'Action',
  render: (value, onChange, label, key, disabled) => (
    <StringRegExFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailMetadataFilterKey = 'audit-trail-metadata-filter';
const auditTrailMetadataFilter: PageFiltersElement<AuditTrailFilterMetadata> = {
  key: auditTrailMetadataFilterKey,
  filterName: 'Metadata',
  inputLabel: 'Metadata',
  render: (value, onChange, label, key, disabled) => (
    <MetadataFilter value={value} onChange={onChange} inputLabel={label} key={key} disabled={disabled} />
  ),
};

export const auditTrailFiltersConfig: AuditTrailFiltersConfig[] = [
  auditTrailDateTimeFilter,
  auditTrailUserFilter,
  auditTrailComponentFilter,
  auditTrailEventSourceFilter,
  auditTrailWorkspaceFilter,
  auditTrailResourceFilter,
  auditTrailStatusFilter,
  auditTrailPrincipalFilter,
  auditTrailIPAddressFilter,
  auditTrailActionFilter,
  auditTrailMetadataFilter,
];
